import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Card from '@components/Card';
import Button from '@shared/Button';
import Modal from '@shared/Modal';
import { ReactComponent as ActiveIcon } from '@src/assets/escher/icons/checkbox-filled-select.svg';
import { ReactComponent as InactiveIcon } from '@src/assets/escher/icons/checkbox-outline-default.svg';
import { ReactComponent as PencilIcon } from '@src/assets/pencil.svg';
import ButtonsRow from '@styled/Containers/ButtonsRow';
import H5 from '@styled/Elements/H5';
import P from '@styled/Elements/P';

import Description from '../components/Description';
import ListModal from '../components/Modal';
import Section from '../components/Section';
import ListTable from '../components/Table';

const FullWidthTableContainer = styled.div`
  width: 100%;
`;
const FullWidthTable = styled.table`
  width: 100%;
  th,
  td {
    cursor: default;
    text-align: center;
    padding: 10px;
  }

  td.clickable {
    cursor: pointer;
  }

  th {
    font-size: 20px;
  }
  tr:not(:last-child) {
    border-bottom: 1px solid #999;
  }

  tr {
    line-height: 30px;
    transition: background-color 0.35s ease;
    cursor: pointer;
    background-color: #fff;
    &:hover {
      background-color: #efefef;

      .hover-icon {
        display: inline-block;
        opacity: 1;
      }
    }

    .hover-icon {
      display: inline-block;
      opacity: 0;
      width: 16px;
      height: 16px;
    }
  }
`;

const NullText = styled.span`
  color: ${props => props.theme.enigmaGrey};
`;
const ActiveText = styled.span`
  color: ${props => props.theme.enigmaBlue};
`;
const InactiveText = styled.span`
  color: ${props => props.theme.enigmaRed};
`;

export default function SanctionList({ data, invalidateCache }) {
  const [selectedListId, setSelectedListId] = React.useState(null);

  let finalData = data || [];

  let selectedList = null;
  if (selectedListId) {
    selectedList = finalData.find(item => item.list_id === selectedListId);
  }

  const handleClose = () => {
    setSelectedListId(null);
  };
  return (
    <FullWidthTableContainer>
      {finalData.length > 0 && <ListTable lists={finalData} setSelectedListId={setSelectedListId} />}
      {selectedList && selectedList.list_id && selectedList.status != 'Suspended' && (
        <ListModal list={selectedList} handleClose={handleClose} invalidateCache={invalidateCache} />
      )}
    </FullWidthTableContainer>
  );
}
